import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import MessageApi from '../../../../api/message';

const WhatsAppTemplatesContext = createContext();

export const useWhatsAppTemplates = () => useContext(WhatsAppTemplatesContext);

export const WhatsAppTemplatesProvider = ({ children }) => {
  const [whatsappTemplates, setWhatsappTemplates] = useState([]);
  const [isWhatsappTemplatesLoading, setIsWhatsappTemplatesLoading] = useState(true);

  const fetchWhatsAppTemplates = useCallback(async () => {
    try {
      setIsWhatsappTemplatesLoading(true);
      const templates = (await MessageApi.getWhatsappTemplates()).data;
      setWhatsappTemplates(templates);
    } catch (error) {
      console.error('Failed to fetch WhatsApp templates', error);
    } finally {
      setIsWhatsappTemplatesLoading(false);
    }
  }, []);

  const getParametersFromText = (text) => {
    if (!text) return [];
    const matches = text.match(/{\s*([^}]+)\s*}/g) || []; // default to empty array if no matches
    return matches.map((val) => {
      return val.replace(/[{}\s]/g, '');
    });
  };

  useEffect(() => {
    fetchWhatsAppTemplates();
  }, [fetchWhatsAppTemplates]);

  const value = {
    whatsappTemplates,
    isWhatsappTemplatesLoading,
    fetchWhatsAppTemplates,
    getParametersFromText,
  };

  return (
    <WhatsAppTemplatesContext.Provider value={value}>{children}</WhatsAppTemplatesContext.Provider>
  );
};
